export const GridHeight = '100%';
export const GridWidth = "100%";

export const Width_1000= 1000;
export const Width_40 = 40;
export const Width_80 = 80;
export const Width_90 = 90;
export const Width_100 = 100;
export const Width_120 = 120;
export const Width_50 = 50;
export const Width_150 =150;
export const Width_175 =175;
export const Width_200=200;
export const Width_300=300;
export const Width_600=600;
export const Width_250=250;
export const Length_30=30;
export const Length_10=10;
export const Length_255=255;
export const BorderColor= '#D6D2D0';